import styles from "./IntegratedCTA.module.scss";
import {
  SecondaryButton,
  UnderlinedButton,
} from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { SaleTagFilled } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/SaleTagFilled";
import { useTradeInContext } from "../../TradeInContext";
import { dispatchCustomEvent } from "../../../../utils/customEvent/dispatchCustomEvent";
import { TradeInEvents } from "../../TradeIn";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

type Props = {
  isFullWidthMode: boolean;
  isTradeInModelLoading: boolean;
  onClick: () => void;
};

export const IntegratedCTAUI = ({
  isFullWidthMode,
  isTradeInModelLoading,
  onClick,
}: Props) => {
  const { productImage, promotionValue, hasPromoCode, flags } =
    useTradeInContext();
  const showNewTradeInUI = flags.showNewTradeInUI.value === true;
  const dispatchTradeInReadMoreEvent = () => {
    dispatchCustomEvent(TradeInEvents.TRADE_IN_READ_MORE_EVENT);
  };

  const PromoMessageBlock = () => (
    <>
      {!!promotionValue && (
        <div className={styles.cta__promo}>
          <p className={styles.cta__promoMessage}>
            <SaleTagFilled size="medium" className={styles.saleTag} />
            {hasPromoCode ? (
              <span>Receive an extra {promotionValue} off with promo code</span>
            ) : (
              <span>Get an extra {promotionValue} when you trade-in</span>
            )}
          </p>
          <UnderlinedButton
            tag="a"
            role="button"
            onClick={() => {
              dispatchTradeInReadMoreEvent();
            }}
            labelText="Read more"
            className={styles.cta__promoButton}
          />
        </div>
      )}
    </>
  );

  return (
    <div
      className={cx(styles.cta, {
        fullWidthMode: isFullWidthMode,
        "cta-new": showNewTradeInUI,
      })}
      data-testid="integrated-cta"
    >
      {showNewTradeInUI ? (
        <>
          <img
            src={`${productImage + "?fmt=auto&amp;$background-off-white$&amp;$rsp-pdp-port-72$"}`}
            width={72}
            alt={"Product image"}
          />
          <h2 className={styles.cta__title}>
            Get up to {promotionValue} when you trade in your old device.
          </h2>

          <UnderlinedButton
            className={styles.cta__button}
            onClick={onClick}
            submitting={isTradeInModelLoading}
            labelText="Get a free estimate now"
          />
          <PromoMessageBlock />
        </>
      ) : (
        <>
          <h2 className={styles.cta__title}>
            Got a device you are no longer using?
          </h2>
          <p className={styles.cta__description}>
            Trade-in now and get some money back when making your new purchase
          </p>
          <SecondaryButton
            onClick={onClick}
            submitting={isTradeInModelLoading}
            labelText="Trade in device"
            width="full-width"
            className={styles.cta__tradeInButton}
          />
          <PromoMessageBlock />
        </>
      )}
    </div>
  );
};
